import { z } from "zod";

export const techStackCategorySchema = z.object({
  categoryId: z.number(),
  category: z.string(),
  logo: z.string().nullable().default(null),
  colorCode: z.string().nullable().default(null),
  techStacks: z.array(
    z.object({
      techStackId: z.number(),
      category: z.string().nullable().optional(),
      techStack: z.string(),
      skillLevel: z
        .enum(["BEGINNER", "INTERMEDIATE", "EXPERIENCED"])
        .nullable()
        .optional(),
      primarySkill: z.boolean().nullable().optional(),
      logo: z.string().nullable().optional(),
    }),
  ),
});

export const techStackMasterSchema = z.array(techStackCategorySchema);

export const employeeTechStackResponseSchema = z.object({
  employeeId: z.number(),
  employeeName: z.string().default(""),
  techStacks: z.array(
    z.object({
      techStackId: z.number(),
      category: z.string().nullable().default(null),
      techStack: z.string(),
      skillLevel: z
        .enum(["BEGINNER", "INTERMEDIATE", "EXPERIENCED"])
        .nullable()
        .optional(),
      experience: z.number().nonnegative().nullable().optional(),
      primarySkill: z.boolean().nullable().default(false),
      logo: z.string().nullable().optional(),
    }),
  ),
});
